import React, {Component} from 'react';
import PropTypes from 'prop-types';
import translate from '../service/translation';
import Select from 'react-select';

export default class MultiSelectFilter extends Component {

    static propTypes = {
        options: PropTypes.array,
        filterKey: PropTypes.string,
        EXTKEY: PropTypes.string,
        value: PropTypes.string,
        handleInputChange: PropTypes.func.isRequired
    };

    render() {
        const {options, filterKey, EXTKEY, value} = this.props;

        return (
            <div className={EXTKEY + '__filter--row row'}>
                <Select isMulti
                        options={options}
                        onChange={(newValue) => this.props.handleInputChange(newValue, filterKey)}
                        value={value}
                        placeholder={translate('list_filter_label_' + filterKey)}
                        isSearchable={true}
                        className={EXTKEY + '__select--multi col-12'}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./React/src/components/MultiSelectFilter.js